import type { CSSProperties } from 'react';
import type { RichTextStyle } from '@/types/ads';
import { resolveTextAdFontFamily } from './textAdFonts';

export function textBlockCss(overrides?: RichTextStyle, defaults: RichTextStyle = {}): CSSProperties {
  const style = { ...defaults, ...Object.fromEntries(Object.entries(overrides ?? {}).filter(([, value]) => value !== undefined)) };
  return {
    fontFamily: style?.fontFamily ? resolveTextAdFontFamily(style.fontFamily) : undefined,
    fontSize: style?.fontSize,
    color: style?.color,
    fontWeight: style?.bold === undefined ? undefined : style.bold ? 'bold' : 'normal',
    fontStyle: style?.italic === undefined ? undefined : style.italic ? 'italic' : 'normal',
    textDecoration: style?.underline ? 'underline' : undefined,
    lineHeight: 1.4,
  };
}

